import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { useLocale } from '../contexts/LocaleContext';

interface VersionHistoryExplanationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const VersionHistoryExplanationModal: React.FC<VersionHistoryExplanationModalProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useLocale();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('how_version_history_works')}</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-4 pt-4 text-left">
              <div className="text-left">
                {t('version_history_explanation_intro')}
              </div>
              <div className="space-y-2 text-left">
                <div className="font-medium text-left">{t('version_history_free_title')}</div>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground text-left">
                  <li className="text-left">{t('version_history_free_days')}</li>
                  <li className="text-left">{t('version_history_free_labels')}</li>
                </ul>
              </div>
              <div className="space-y-2 text-left">
                <div className="font-medium text-left">{t('version_history_paid_title')}</div>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground text-left">
                  <li className="text-left">{t('version_history_paid_unlimited')}</li>
                  <li className="text-left">{t('version_history_paid_daily')}</li>
                  <li className="text-left">{t('version_history_paid_thinning')}</li>
                </ul>
              </div>
              <div className="text-sm text-muted-foreground text-left">
                {t('version_history_explanation_footer')}
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end pt-4">
          <Button
            onClick={() => onOpenChange(false)}
            variant="outline"
            className="bg-card text-foreground border-border hover:bg-muted"
          >
            {t('got_it')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
